<template>
  <div class="Charts2Border" :style="backgroundStyle">
    <!-- <div
      class="charts-controller"
      :style="{
        fontSize: $w_Ratio(0, $store) + 'px',
        width: $w_Ratio(80, $store) + 'px',
        height: $h_Ratio(25, $store) + 'px',
        top: $h_Ratio(4, $store) + 'px',
      }"
    >
      <div
        class="charts-c charts-c-sm"
        @mouseenter="handleEnterSM(true)"
        @mouseleave="handleEnterSM(false)"
        :style="{}"
      >
        <img
          src="/img/chartsController/smallify.png"
          :style="{
            transform: `rotate(180deg) translateY(100px)`,
            filter: `drop-shadow(${titleStyle.titleColor} 0px -100px 0px)`,
            backgroundColor: controllerBK.SM,
          }"
          alt=""
        />
      </div>
      <div
        class="charts-c charts-c-mi"
        @mouseenter="handleEnterMI(true)"
        @mouseleave="handleEnterMI(false)"
        :style="{}"
      >
        <img
          src="/img/chartsController/minimize.png"
          :style="{
            transform: `rotate(180deg) translateY(100px)`,
            filter: `drop-shadow(${titleStyle.titleColor} 0px -100px 0px)`,
            backgroundColor: controllerBK.MI,
          }"
          alt=""
        />
      </div>
      <div
        class="charts-c charts-c-ma"
        @mouseenter="handleEnterMA(true)"
        @mouseleave="handleEnterMA(false)"
        :style="{}"
      >
        <img
          src="/img/chartsController/maximize.png"
          :style="{
            transform: `rotate(0deg) translateY(100px)`,
            filter: `drop-shadow(${titleStyle.titleColor} 0px -100px 0px)`,
            backgroundColor: controllerBK.MA,
          }"
          alt=""
        />
      </div>
    </div> -->
    <div class="header">
      <span
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 600,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
        >{{ Configuration.propertyData.titleText.value }}</span
      ><span
        class="b-mtline-dec"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          paddingLeft: $w_Ratio(8, $store) + 'px',
          backgroundImage: `-webkit-linear-gradient(left, ${titleStyle.titleColor}, rgba(0, 0, 0, 0))`,
        }"
        >////////////////////</span
      >
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Charts2Border',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      backgroundStyle: {},
      titleStyle: {
        titleSize: 18,
        titleColor: '#ccc',
      },

      controllerBK: {
        SM: '',
        MI: '',
        MA: '',
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        this.setChartsOptionsFontColor();
      },
    },
  },
  created() {
    this.setChartsOptionsFontColor();
  },
  methods: {
    setChartsOptionsFontColor() {
      if (this.Configuration.propertyData.fontStyle) {
        let { titleSize, titleColor } = this.Configuration.propertyData.fontStyle.value;
        this.titleStyle = {
          titleSize: parseInt(titleSize),
          titleColor,
        };
      }
    },
    handleEnterSM(isActive) {
      if (isActive) {
        this.controllerBK.SM = this.$tinycolor(this.titleStyle.titleColor)
          .setAlpha(0.3)
          .toRgbString();
      } else {
        this.controllerBK.SM = '';
      }
    },
    handleEnterMI(isActive) {
      if (isActive) {
        this.controllerBK.MI = this.$tinycolor(this.titleStyle.titleColor)
          .setAlpha(0.3)
          .toRgbString();
      } else {
        this.controllerBK.MI = '';
      }
    },
    handleEnterMA(isActive) {
      if (isActive) {
        this.controllerBK.MA = this.$tinycolor(this.titleStyle.titleColor)
          .setAlpha(0.3)
          .toRgbString();
      } else {
        this.controllerBK.MA = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.Charts2Border {
  // position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  .charts-controller {
    overflow: hidden;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100px;
    height: 22px;
    display: flex;
    justify-content: space-around;
    // align-items: center;
    // z-index: 0;
    .charts-c {
      width: 22%;
      height: 70%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .header {
    display: flex;
    align-items: flex-start;
    padding-top: 1%;
    padding-bottom: 1%;
    .b-mtline-dec {
      //   background-image: -webkit-linear-gradient(left, #00a2ff, rgba(0, 0, 0, 0));
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 1000;
    }
  }
}
</style>
